module.exports = __webpack_public_path__ + "img/ico-check-blue.161ea5d1.svg";